.uic-radio {
  /**

    @prop --uic-radio-indicator-outer-size: the size of the indicator container
    @prop --uic-radio-indicator-inner-size: the size of the checked indicator

    */

  display: inline;
  outline: 0;
  padding: 4px 8px;

  &:hover,
  &:active,
  &:focus-visible {
    .uic-radio__label,
    .uic-radio__icon {
      color: var(--uic-color-blue3);
    }

    .uic-radio__indicator {
      border-color: var(--uic-color-blue2);
    }
  }

  &:active .uic-radio__indicator {
    background: var(--uic-color-blue0a40);
  }

  &:focus-visible .uic-radio__indicator {
    border: 2px solid var(--uic-color-blue2);
  }

  &__control {
    align-items: center;
    cursor: pointer;
    display: inline-flex;
    flex-flow: row nowrap;
    min-height: 40px;
    position: relative;
    user-select: none;
  }

  &__indicator {
    align-items: center;
    background: var(--uic-color-white);
    border: 1px solid var(--uic-color-grey2);
    border-radius: 50%;
    box-sizing: border-box;
    display: flex;
    height: var(--uic-radio-indicator-outer-size);
    justify-content: center;
    width: var(--uic-radio-indicator-outer-size);

    &::after {
      border-radius: 50%;
      content: '';
      display: block;
      height: var(--uic-radio-indicator-inner-size);

      width: var(--uic-radio-indicator-inner-size);
    }
  }

  &__input {
    @include visually-hidden();
  }

  &__label {
    @include font(normal);
    align-items: center;
    color: var(--uic-color-black);
    display: flex;
    gap: 8px;

    &:not(:empty) {
      margin-left: 10px;
    }
  }

  &__icon {
    color: var(--uic-color-grey3);
  }

  &--checked {
    .uic-radio__indicator {
      border-color: var(--uic-color-blue2);

      &::after {
        background: var(--uic-color-blue4);
      }
    }

    &:active {
      .uic-radio__indicator {
        background: var(--uic-color-blue0a40);
      }
    }

    &:active,
    &:hover {
      .uic-radio__indicator::after {
        background: var(--uic-color-blue3);
      }
    }

    &:focus-visible .uic-radio__indicator::after {
      background: var(--uic-color-black);
    }
  }

  &--disabled {
    pointer-events: none;

    .uic-radio__indicator {
      border-color: var(--uic-color-grey2a25);
    }

    &.uic-radio--checked {
      .uic-radio__indicator::after {
        background: var(--uic-color-blacka50);
      }
    }

    .uic-radio__label {
      color: var(--uic-color-grey3a75);
    }

    .uic-radio__icon {
      color: var(--uic-color-grey5);
    }
  }
}
